import React from 'react';
import { Redirect } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { ROUTE_PATHS } from '../contants/ROUTE_PATHS';

export default function ProtectedRoute(props: any) {
  const Component = props.component;
  const auth = useSelector((state: any) => state.auth);
  if (auth.loading) {
    return <></>;
  }
  if (!auth.authenticated) {
    return (<Redirect to={{ pathname: ROUTE_PATHS.PROTECTED }} />);
  }
  if (!(auth.currUser && auth.currUser.emailVerified)) {
    return (<Redirect to={{ pathname: ROUTE_PATHS.UNVERIFIED }} />);
  }
  return <Component {...props} />;
}
